
import { useUserContext } from 'features/users';
import React, { createContext, ReactNode,useContext, useEffect, useState } from "react";

interface NotificationContextType {
  unreadCount: number;
  setUnreadCount: (count: number) => void;
  incrementUnread: () => void;
  decrementUnread: () => void;
  resetUnread: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState<number>(0);

  const incrementUnread = () => setUnreadCount((prev) => prev + 1);
  const decrementUnread = () => setUnreadCount((prev) => Math.max(prev - 1, 0));
  const resetUnread = () => setUnreadCount(0);
  
   const { user } = useUserContext();

     
 
   useEffect(() => {
    if (user?.totalUnReadNotification != null) {
      setUnreadCount(user?.totalUnReadNotification);
    }
  }, [user]);

 

   
  return (
      <NotificationContext.Provider
      value={{ unreadCount, setUnreadCount, incrementUnread, decrementUnread, resetUnread }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = (): NotificationContextType => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within a NotificationProvider");
  }
  
return context;
};



